import { useQuery } from '@tanstack/react-query';
import { useLocation, useMatches, useNavigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { TablePagination } from '@/libs/serenity-ui';
import type { RouterContext } from '@/routes/__root';
import { Route, type ListRouteContext } from '@/routes/_main/_list';

export function Pagination(): ReactElement {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const location = useLocation();
  const matches = useMatches();

  const routeContext = matches.at(-1)?.context as RouterContext & ListRouteContext;

  const listQuery = useQuery(routeContext.queryOptions.list);

  return (
    <TablePagination
      currentPage={search.pagination.pageIndex + 1}
      pageSize={search.pagination.pageSize}
      pageSizeOptions={[ 25, 50, 75, 100 ]}
      totalResults={listQuery.data?.totalCount ?? 0}
      onPageChange={(page) => navigate({
        to: location.pathname,
        search: {
          ...search,
          pagination: { ...search.pagination, pageIndex: page - 1 },
        },
      })}
      onPageSizeChange={(pageSize) => navigate({
        to: location.pathname,
        search: {
          ...search,
          pagination: { ...search.pagination, pageSize, pageIndex: 0 },
        },
      })}
    />
  );
}
